import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  Icons,
  TimelineLegacy,
  TTimelineItemLegacyType,
  TTimelineItemStatusLegacy,
} from '@commenda/kakashi';

interface FilingTimelineProps {
  title?: string;
  steps: TTimelineItemLegacyType[];
  helpText?: {
    text: string;
    linkText?: string;
    onLinkClick?: () => void;
  };
  overdueText?: {
    text: string;
    linkText?: string;
    onLinkClick?: () => void;
  };
  className?: string;
}

const FilingTimeline = ({
  title = 'Estimated timeline',
  steps,
  helpText,
  overdueText,
  className = '',
}: FilingTimelineProps) => {
  const hasOverdueStep = steps.some(
    (step) => step.status === TTimelineItemStatusLegacy.OVERDUE
  );

  return (
    <Accordion
      className={`max-w-[316px] w-[316px] rounded-md ${className}`}
      type="single"
      collapsible
      defaultValue="item-1"
    >
      <AccordionItem
        className="rounded-md bg-bg-secondary border border-border-primary"
        value="item-1"
      >
        <AccordionTrigger className="cursor-pointer px-xl py-xl flex justify-between">
          <div className="flex items-center gap-2">
            <p className="txt-small-medium text-text-secondary">{title}</p>
            {hasOverdueStep && (
              <Icons.AlertCircle className="size-4 text-text-error" />
            )}
          </div>
        </AccordionTrigger>
        <AccordionContent className="p-xl pt-0 border-t-0 flex flex-col gap-xl">
          <TimelineLegacy
            steps={steps}
            setActiveStep={() => {}}
            hideTail={false}
          />

          {(overdueText || helpText) && (
            <p className="txt-small-regular text-text-secondary">
              {hasOverdueStep && overdueText ? (
                <>
                  {overdueText.text}{' '}
                  {overdueText?.onLinkClick && (
                    <Button
                      onClick={overdueText?.onLinkClick}
                      variant="link"
                      className="text-text-link hover:underline"
                    >
                      {overdueText?.linkText}
                    </Button>
                  )}
                </>
              ) : (
                helpText && (
                  <>
                    {helpText.text}{' '}
                    {helpText?.onLinkClick && (
                      <Button
                        onClick={helpText?.onLinkClick}
                        variant="link"
                        className="text-text-link hover:underline"
                      >
                        {helpText?.linkText}
                      </Button>
                    )}
                  </>
                )
              )}
            </p>
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export { FilingTimeline };
